import { Injectable } from '@angular/core';

import { OddsOperations, emptyOdds } from '@frontend/sports/odds/feature';

import { BaseBetslipGroupPick } from '../../../../../../core/picks/betslip-group-pick';
import { BetslipPick } from '../../../../../../core/picks/betslip-pick';
import { IPrice, PickOddsState } from '../../../../../../core/picks/pick-models';
import { GroupPickInvalidPricePreCheckError } from '../../../../errors/general/group-pick-error';
import { IPureLinearPickValidator } from '../validators';

@Injectable()
export class GroupPickInvalidPriceValidator implements IPureLinearPickValidator<GroupPickInvalidPricePreCheckError> {
    validate(pick: BetslipPick): GroupPickInvalidPricePreCheckError[] {
        const isInvalidPrice =
            BaseBetslipGroupPick.isPick(pick) && pick.oddsState === PickOddsState.Open && this.isInvalidPrice(pick.actualGroupPrice);

        return isInvalidPrice ? [new GroupPickInvalidPricePreCheckError(pick.id.toString())] : [];
    }

    private isInvalidPrice(price: IPrice | undefined): boolean {
        return OddsOperations.equal(price?.nativeOdds ?? emptyOdds, emptyOdds);
    }
}
